

































































































import { Vue, Component, Prop } from 'vue-property-decorator';

import { formatTemperature } from '~/utils/units.js';

import ProfileRunSportTag from '~/components/partials/ProfileRunSportTag.vue';
import ExperiencesPicker from '~/components/lists/ExperiencesPicker.vue';
import ArrowNarrowRightSolid from '~/components/icons/ArrowNarrowRightSolid.vue';
import RespectCard from '~/components/cards/RespectCard.vue';
import LabelsInfos from "~/components/partials/LabelsInfos.vue";

@Component({
  components: { LabelsInfos, RespectCard, ProfileRunSportTag, ExperiencesPicker, ArrowNarrowRightSolid },
})
export default class DestinationJumbo extends Vue {
  @Prop(Object) destination: Types.DestinationItem;
  @Prop(Array) destinationSports: [];
  @Prop(Boolean) isLoading: false;
  @Prop(Object) weatherDatas: {};

  formatTemperature: Function = formatTemperature;
  initCrossFade: any = null;

  image: string = '';
  increment: number = 0;

  /*
    We will display first image by default, so there is always one image displayed
    when robots crawl page
  */
  created () {
    this.image = this.destination.header_pictures[0];
  }

  /*
    We implement the setInterval logic in mounted so the slider will be available
    client-side. The slider increments image in array, and goes back to first one
    when reaching last array.
  */
  mounted () {
    const self: any = this;
    this.initCrossFade = setInterval(function () {
      self.increment === self.destination.header_pictures.length - 1 ? self.increment = 0 : self.increment++;
      self.image = self.destination.header_pictures[self.increment];
    }, 6000);
  }

  /* Clears interval when destroying page */
  beforeDestroy () {
    clearInterval(this.initCrossFade);
  }
}
